export const tr = {
    "socialMedia": {
        "facebook": "https://www.facebook.com/investturkey",
        "instagram": "https://www.instagram.com/investinturkiye_en",
        "linkedin": "https://www.linkedin.com/company/invest-in-turkey",
        "x": "https://twitter.com/InvestTurkey",
        "youtube": "https://www.youtube.com/c/InvestinT%C3%BCrkiye"
    },
    "heroSection": {
        "tagline": "DYY STRATEJİSİ",
        "heading": "Doğrudan Yabancı Yatırım Stratejisi",
        "description": "Bu stratejik yol haritası, Türkiye'nin ekonomik gelişim hedeflerine uygun yüksek kaliteli DYY yatırımlarını çekmeyi amaçlamaktadır."
    },
    "headerMenu": {
        "currentLanguage": {
            "code": "TR",
            "icon": ""
        },
        "optionalLanguages": [
            {
                "code": "EN",
                "label": "English",
                "icon": "",
                "link": "/en"
            }
        ],
        "menuItems": [
            {
                "name": "ANA SAYFA",
                "link": "/",
                "icon": null
            },
            {
                "name": "FİNANSAL KAYNAKLAR",
                "link": "/listing",
                "icon": null
            }
        ],
        "mobileMenuButton": {
            "icon": "",
            "label": "Menü"
        },
        "discoverButton": {
            "text": "Keşfedin",
            "link": "/listing",
            "icon": ""
        },
        "downloadButton": {
            "text": "PDF İndir",
            "link": "/documents/TR-FDI-Strategy-Report-Reduced.pdf",
            "icon": ""
        }
    },
    "form": {
        "placeholder": "E-posta adresiniz..",
        "submitText": "Başlayın",
        "successMessage": "Teşekkürler! Gönderiminiz alındı!",
        "errorMessage": "Form gönderilirken bir sorun oluştu."
    },
    "footerMenu": {
        "logoLink": "/",
        "downloadPdf": {
            "text": "PDF İndir",
            "link": "/documents/TR-FDI-Strategy-Report-Reduced.pdf",
            "icon": ""
        },
        "menuItems": [
            {
                "title": "ANA SAYFA",
                "link": "/"
            },
            {
                "title": "YATIRIM OFİSİ",
                "link": "https://invest.gov.tr/",
                "subLinks": [
                    {
                        "title": "Türkiye UDY Stratejisi",
                        "link": "/insights#fdi-outlook"
                    },
                    {
                        "title": "UDY Sözlüğü",
                        "link": "/insights#fdi-performance"
                    },
                    {
                        "title": "FDI Agenda Newsletter",
                        "link": "/insights#key-findings"
                    }
                ]
            }
        ],
        "actionPlan": {
            "title": "FİNANSAL KAYNAKLAR",
            "link": "/listing",
            "subLinks": [
                {
                    "title": "Girişim Sermayesi Yatırım Fonları",
                    "link": "/action-plans#01"
                },
                {
                    "title": "Melek Yatırım Ağları",
                    "link": "/action-plans#02"
                },
                {
                    "title": "Hızlandırıcı ve Kuluçkalar",
                    "link": "/action-plans#03"
                },
                {
                    "title": "Yatırımcılar/Fonlar",
                    "link": "/action-plans#04"
                },
                {
                    "title": "Kurumsal Girişim Sermayesi",
                    "link": "/action-plans#05"
                },
                {
                    "title": "Etki Yatırımı ve Etki Odaklı Fonlar",
                    "link": "/action-plans#06"
                },
                {
                    "title": "Kitle Fonlama Platformları",
                    "link": "/action-plans#06"
                },
                {
                    "title": "Hibe ve Destek Mekanizmaları",
                    "link": "/action-plans#06"
                }
            ]
        }
    },
    "DiscoverResources": {
        "tagline": "TÜRKİYE YATIRIM EKOSİSTEMİ",
        "heading": "Finansal Kaynakları Keşfedin",
        "paragraph": "Bu rehber, bir girişimci olarak kaynak yaratma ve organizasyonları tanıma yolundaki ilk adımınız olacaktır. Girişiminiz için kaynak bulma ve ekosistemi tanımak amacıyla özenle hazırlanmıştır.",
        "buttonText": "Fonları Keşfedin"
    },
    "HeroCards": {
        "card1": {
            "title": "Girişim Sermayesi<br />Yatırım Fonları",
            "description": "144 Fon",
            "link": "#"
        },
        "card2": {
            "title": "Melek Yatırımcılar",
            "description": "Yakında",
            "link": "#"
        },
        "card3": {
            "title": "$ 400",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card4": {
            "title": "0",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card5": {
            "title": "Kitle Fonlama<br />Platformları",
            "description": "Yakında",
            "link": "#"
        },
        "card6": {
            "title": "0",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card7": {
            "title": "0",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card8": {
            "title": "Hızlandırma<br />Merkezleri",
            "description": "Yakında",
            "link": "#"
        }
    },
    "testimonials": [
        {
            "quote": "Türkiye'nin yatırım ekosistemi, vizyoner yatırımcıların girişimcilere rehberlik ettiği ve destek verdiği canlı bir merkezdir. Stratejik konumu ve çeşitli pazar fırsatları, yenilikçi fikirleri küresel ölçekte ölçeklendirmek için ideal bir başlangıç noktasıdır.",
            "name": "Caner Aras",
            "title": "Designvest Kurucusu",
            "avatar": "images/Testimonial-Avatar-Image.png",
            "episodes": {
                "spotify": "https://invest.tr/talks-02-spotify",
                "youtube": "https://invest.tr/talks-02-youtube",
                "apple": "https://invest.tr/talks-02-apple"
            }
        },
        {
            "quote": "Türkiye’nin gelişen girişimcilik ekosistemi, inovasyonu ve büyümeyi desteklemeye içtenlikle inanan yatırımcılarla besleniyor. İşbirliği ortamı ve çeşitli pazarlara erişim, cesur fikirleri etkili girişimlere dönüştürmek için benzersiz bir yer yapıyor.",
            "name": "Lorem Ipsum",
            "title": "LoremIpsum Kurucusu",
            "avatar": "images/Team-Headshot-6.png",
            "episodes": {
                "spotify": "https://invest.tr/talks-02-spotify",
                "youtube": "https://invest.tr/talks-02-youtube",
                "apple": "https://invest.tr/talks-02-apple"
            }
        }
    ],
    "keyTrends": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Türkiye'nin Girişim Ekosistemi Hakkında Bilgi Edinin",
        "description": "Birbirinden değerli içeriklerle Türkiye'nin girişim ekosistemi hakkında bilgi edinin. İçerikleri inceleyin.",
        "slides": [
            {
                "tagline": "MİKRO WEB SİTESİ",
                "title": "Türkiye'nin UDY Stratejisini İnceleyin",
                "description": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "button": "Stratejiyi İnceleyin",
                "backTitle": "Türkiye'nin UDY Stratejisini İnceleyin",
                "backDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "backButton": "İnceleyin"
            },
            {
                "tagline": "RAPOR",
                "title": "Türkiye Startup Ekosistem Raporu",
                "description": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "button": "Raporu İnceleyin",
                "backTitle": "Türkiye Startup Ekosistem Raporu",
                "backDescription": "Jeopolitik gerilimler, iklim değişikliği, salgınlar ve sürdürülebilirlik kavramları, küresel değer zincirlerini yeniden şekillendiriyor.",
                "backButton": "İnceleyin"
            },
            {
                "tagline": "RAPOR",
                "title": "Türkiye Oyun Girişimleri Ekosistem Raporu",
                "description": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "button": "Stratejiyi İnceleyin",
                "backTitle": "Türkiye Oyun Girişimleri Ekosistem Raporu",
                "backDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "backButton": "İnceleyin"
            },
            {
                "tagline": "MİKRO WEB SİTESİ",
                "title": "UDY Sözlüğünü İnceleyin",
                "description": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "button": "Sözlüğü Keşfedin",
                "backTitle": "UDY Sözlüğünü İnceleyin",
                "backDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "backButton": "İnceleyin"
            },
            {
             
                "tagline": "BÜLTEN",
                "title": "Aylık Bültene Abone Olun",
                "description": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "button": "Bültene Kaydolun",
                "backTitle": "Aylık Bültene Abone Olun",
                "backDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing.",
                "backButton": "İnceleyin"
            }
        ]
    },
    "listing":{
        "allFinancialResources": "Tüm Finansal Kaynaklar",
        "startupStage": "Girişim Aşaması",
        "organizationsAvailable": "{{count}} Organizasyon Mevcut",
        "sorting": "Sıralama",
        "alphabeticalOrder": "Alfabetik Sıralama",
        "fromAToZ": "A'dan Z'ye",
        "startupArea": "Girişim Alanı",
        "selectionsMade": "{{count}} Seçim Yapıldı",
        "all": "Tümü",
        "noResultsFound": "Sonuç bulunamadı",
        "dealSize": "İşlem Büyüklüğü",
        "fundSize": "Fon Büyüklüğü",
        "getDetailedInfo": "Detaylı Bilgi Alın",
        "otherFilters": "Diğer Filtreler",
        "turkeyBasedResources": "Türkiye Merkezli Kaynaklar",
        "organizationsBasedInTurkey": "Merkezi Türkiye'de bulunan kurumlar.",
        "governmentInstitutions": "Kamu Kurumları",
        "stateSupportedResources": "Devlet destekli kaynaklar.",
        "reset": "Sıfırla",
        "featureYourFundHere": "Fonunuzu Burada Tanıtın",
        "missingFundPrompt": "Fonunuz eksik mi? <br/> Fonunuzu Gönderin",
        "featureYourFund": "Fonunuzu Tanıtın",
        "readMore": "Daha Fazla",
        "selectCategory": "Kategori Seçin",
        "categoriesAvailable": "{{count}} Kategori Mevcut",
        "sectorIndependent": "Sektör Bağımsız",
        "confirmSelection": "Seçimi Onayla",
        "search":"Ara",
        "alphabetical": "Alfabetik",
        "byFundSize": "Fon Büyüklüğüne Göre",
        "largeToSmall": "Büyükten Küçüğe",
        "byDealSize": "İşlem Büyüklüğüne Göre",
        "smallToLarge": "Küçükten Büyüğe",
        "byEstablishmentDate": "Kuruluş Tarihine Göre",
        "newToOld": "Yeniden Eskiye",
        "focusAreas": "ODAK ALANLARI",
        "fundHeadquarters":"Fon Merkezi",
        "yearOfEstablishment":"Kuruluş Yılı",
        "geographicalInvestmentPreference":"Coğrafi Yatırım Tercihi"
      }
}